export default {"src":"/_next/static/media/size-limit-icon-10mb.8eec1edc.svg","height":51,"width":50,"blurWidth":0,"blurHeight":0};